
import { useModalStore } from "../../../stores/modalStore.js";
import ThreadPanel from "../ThreadPanel.jsx";

export function ThreadsModal() {
  const { isOpen, type, onClose } = useModalStore();

  if (!isOpen || type !== "threads") return null;

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}
      onClick={onClose}
    >
      <div onClick={(e) => e.stopPropagation()} style={{ width: "90%", maxWidth: 520 }}>
        <ThreadPanel />
      </div>
    </div>
  );
}
